module.exports = __webpack_public_path__ + "img/competitor.ebf7ae92.png";